/**
 * This file contains utility functions about internationalization
 */

/**
 * Get locale name of the current page
 * @returns {string} a BCP 47 extension sequence of the current page (ex: en-UK)
 */
export function getCurrentLocaleName() {
    return window.GLOBAL_KZ && window.GLOBAL_KZ.langTag ?
        window.GLOBAL_KZ.langTag :
        document.documentElement.lang;
}

/**
 * Get list of the day of the week in given local
 * @param {*} localeName BCP 47 extension sequence
 * @param {*} weekday weekday format option ('long', 'short' or 'narrow')
 * @returns {string[]} List of the days of the week, starting sunday
 */
export function getDaysOfTheWeek(localeName = getCurrentLocaleName(), weekday = 'long') {
    const formatter = new Intl.DateTimeFormat(localeName, { weekday });
    const days = [];
    for (let i = 0; i < 7; i++) {
        days.push(formatter.format(new Date(1970, 0, 4 + i)));
    }
    return days;
}
